import React, { Component } from "react";
import {
  Typography,
  Paper,
  Tabs as Tabs1,
  Tab as Tab1,
} from "@material-ui/core";
import { Tabs, Tab } from "react-bootstrap";
import { GetData } from "../../api/service";
import AcademicAbout from "./AcademicAbout";
import CollegeNotificationShort from "../College/CollegeNotificationShort";

const smallTab = [
  {
    title: "Why Dispur College",
    active: 0,
  },
  {
    title: "Pillars of Strength",
    active: 1,
  },
  {
    title: "Course Overview",
    active: 2,
  },
  {
    title: "Internship Procedure",
    active: 3,
  },
  {
    title: "IPO Registration",
    active: 4,
  },
  {
    title: "Our Collaborations",
    active: 5,
  },
  {
    title: "Past IPOs",
    active: 6,
  },
  {
    title: "Stories of Success",
    active: 7,
  },
];

class AcademicHomeLanding extends Component {
  state = {
    active: 0,
    dept_code: "DISPUR",

    data: {},
    isDeptLoaded: false,
  };

  __getDeptData = (dept_code) => {
    GetData(`/admin/${dept_code}/getsingledeptdata`).then((resp) => {
      //console.log(resp)
      if (resp != false) {
        this.setState({
          data: resp,
          active: 0,
          isDeptLoaded: true,
        });
      } else {
        this.setState({
          data: {},
          active: 0,
          isDeptLoaded: true,
        });
      }
    });
  };

  componentDidMount() {
    this.__getDeptData(this.state.dept_code);
  }

  render() {
    return (
      <div>
        <Typography variant="h6">Internship Providing Organizations</Typography>
        <Typography variant="subtitle2">
          Code: {this.state.dept_code}
        </Typography>

        <br />

        {this.state.isDeptLoaded && (
          <Paper square>
            <Tabs1
              value={this.state.active}
              indicatorColor="primary"
              textColor="primary"
              onChange={(e, newValue) =>
                this.setState({
                  active: newValue,
                })
              }
              aria-label=""
            >
              {smallTab.map((el, index) => (
                <Tab1 value={el.active} key={el.active} label={el.title} />
              ))}
            </Tabs1>
          </Paper>
        )}
        <br />
        {this.state.active == 0 ? (
          <AcademicAbout type={`DISPUR_COLLEGE`} title="Add" />
        ) : null}
        {this.state.active == 1 ? (
          <AcademicAbout type={`PILLARS_STRENGHT`} title="Add" />
        ) : null}
        {this.state.active == 2 ? (
          <AcademicAbout type={`COURSE_OVERVIEW`} title="Add" />
        ) : null}
        {this.state.active == 3 ? (
          <AcademicAbout type={`INTERNSHIP_PROCEDURE`} title="Add" />
        ) : null}
       

        {this.state.active == 4 ? (
          
          <CollegeNotificationShort
            type={`IPO_REGISTRATION`}
            title="Add "
          />
        ) : null}

        {this.state.active == 5 ? (
          <CollegeNotificationShort
            type={`COLLABORATIONS`}
            title="Add Our Collaborations"
          />
        ) : null}

        {this.state.active == 6 ? (
          <CollegeNotificationShort
            type={`PAST_IPOS`}
            title="Add Past IPOs"
          />
        ) : null}

        {this.state.active == 7 ? (
          <CollegeNotificationShort type={`STORIES_OF_SUCCESS`} title="Add Stories of Success" />
        ) : null}
      </div>
    );
  }
}

export default AcademicHomeLanding;
